import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailButtonComponent } from '../email-button/email-button.component';
import { EmailMarginComponent } from '../email-margin/email-margin.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-referral',
  styleUrls: ['./email-referral.component.less'],
  template: `
    <table cellspacing="0" cellpadding="0" class="referral">
      <td align="left">
        <email-text [contents]="candidateName" className="candidate-name" />
        <email-margin [height]="4" />
        <email-text [contents]="offerTitle" className="offer-title" />
      </td>
      <td align="right">
        <email-button [href]="jobButtonLink" [label]="jobButtonText" [inline]="true" />
        <email-button
          *mailgunIf="referralStatusVisible"
          [href]="referralButtonLink"
          [label]="referralButtonText"
          [inline]="true"
        />
      </td>
    </table>
  `,
  imports: [
    EmailTextComponent,
    EmailMarginComponent,
    EmailButtonComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailReferralComponent {
  @Input({ required: true }) public candidateName: WrappedValue<string>;
  @Input({ required: true }) public offerTitle: WrappedValue<string>;
  @Input({ required: true }) public jobButtonLink: WrappedValue<string>;
  @Input({ required: true }) public jobButtonText: WrappedValue<string>;
  @Input({ required: true }) public referralButtonLink: WrappedValue<string>;
  @Input({ required: true }) public referralButtonText: WrappedValue<string>;
  @Input({ required: true }) public referralStatusVisible: WrappedValue<boolean>;
}
